import React, { useState, useEffect } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import { Header, Footer, HeaderBox } from '../../components/imports'

import { APP_NAME, PHOTO_BLOG_ROOT } from '../../constants/general'
import Fetch from '../../class/Fetch';

function BlogSingle() {

    const { url } = useParams()

    const navigate = useNavigate()

    const [article, setArticle] = useState(false)

    const getArticle = async () => {

        window.scrollTo(0, 0)

        if (url == null) navigate('/404')

        let results = await Fetch.post('blog/single', { url: url })

        if (results.code == 200) {

            setArticle(results.data)

            document.title = results.data.title + " - " + APP_NAME

        } else {

            navigate('/404')

        }


    }

    useEffect(() => {

        getArticle()

        document.body.classList.remove('mn')

    }, [url])


    return (
        <div>

            <Header />

            <div>

                <HeaderBox />

                <div className="cc content page_page">

                    {

                        article

                            ?

                            <>

                                <h1 className='h cl4 fw3 fz17 mb40'>{article.title}</h1>

                                <img src={PHOTO_BLOG_ROOT + article.image} alt={article.title} className='mb20 br5' />

                                <div dangerouslySetInnerHTML={{ __html: article.text }}></div>

                            </>

                            :

                            <div className='flex jc-center mt50 mb50'>
                                <div className="lds-dual-ring col"></div>
                            </div>

                    }

                </div>

                <Footer />

            </div>

        </div>
    )

}

export default BlogSingle